import { useEffect } from "react";
//#region types
import { CustomerFormTypes } from "models/formTypes";
import { SelectInputItemProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
import { getFortnoxColumnMapping } from "./fortnoxColumnMapping";

/** Pre-fills the column mapping when the uploaded file is a Fortnox customer export. */
function useFortnoxAutoMapping(
  headers: SelectInputItemProps[],
  csvUpload: CustomerFormTypes.CustomerImport["csvUpload"],
  setValues: (values: CustomerFormTypes.CustomerImport) => void
) {
  useEffect(() => {
    const fortnoxMapping = getFortnoxColumnMapping(headers.map((header) => String(header.value)));
    if (fortnoxMapping) {
      setValues({ csvUpload, ...fortnoxMapping });
    }
  }, [headers]);
}

export default useFortnoxAutoMapping;
